import { render } from "./theme-color.vue?vue&type=template&id=fd45f3c8"
import script from "./theme-color.vue?vue&type=script&lang=js"
export * from "./theme-color.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__